import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const login = createAsyncThunk(
  'auth/login',
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const response = await api.post('/auth/login', {
        username,
        password,
      });
      
      if (response.data.success) {
        localStorage.setItem('token', response.data.data.token);
        return response.data.data;
      } else {
        return rejectWithValue(response.data.error || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error.response || error);
      return rejectWithValue(
        error.response?.data?.error?.message || 
        error.response?.data?.error || 
        error.message || 
        'Network error. Please try again.'
      );
    }
  }
);

const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: !!localStorage.getItem('token'),
  user: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.removeItem('token');
      state.token = null;
      state.isAuthenticated = false;
      state.user = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.token = action.payload.token;
        state.user = action.payload.user;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = typeof action.payload === 'string' 
          ? action.payload 
          : 'Login failed. Please check your credentials.';
      });
  },
});

export const { logout, clearError } = authSlice.actions;
export default authSlice.reducer; 